import axios from 'axios';

// Create an Axios instance
//const axiosInstance = axios.create({
//    baseURL: `/api`,
//});
const axiosInstance = axios.create({
    //baseURL: 'https://quantexa-assessment-backend-ca.orangeglacier-e0592306.westeurope.azurecontainerapps.io/api'
    //baseURL: process.env.REACT_APP_API_URL || '/api'  // fallback for local dev
    baseURL: '/api'  // always use /api - nginx handles the proxy
});

// Intercept requests to attach the token
axiosInstance.interceptors.request.use(
    (config) => {
        // Retrieve the token from localStorage or props (modify as needed)
        const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // Attach the token
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

export default axiosInstance;
